/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CouponDto } from './coupon-dto';


export interface CouponEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * Coupon ID
     */
    couponId: string;
    /**
     * Coupon event type
     */
    couponEventType: CouponEventDto.CouponEventTypeEnum;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username
     */
    userName: string;
    /**
     * Coupon event type
     */
    eventType: CouponEventDto.EventTypeEnum;
    /**
     * Interaction ID
     */
    interactionId: string;
    /**
     * Subject information
     */
    subject: CouponDto;
}
export namespace CouponEventDto {
    export type CouponEventTypeEnum = 'COUPON_CREATED' | 'COUPON_UPDATED' | 'COUPON_TERMINATED';
    export const CouponEventTypeEnum = {
        Created: 'COUPON_CREATED' as CouponEventTypeEnum,
        Updated: 'COUPON_UPDATED' as CouponEventTypeEnum,
        Terminated: 'COUPON_TERMINATED' as CouponEventTypeEnum
    };
    export type EventTypeEnum = 'COUPON_CREATED' | 'COUPON_UPDATED' | 'COUPON_TERMINATED';
    export const EventTypeEnum = {
        Created: 'COUPON_CREATED' as EventTypeEnum,
        Updated: 'COUPON_UPDATED' as EventTypeEnum,
        Terminated: 'COUPON_TERMINATED' as EventTypeEnum
    };
}


